/**
 * Match Status Badge Component
 *
 * Displays a colored badge based on ingredient matching confidence:
 * - Green: High confidence match (85%+)
 * - Amber: Review needed (70-84%)
 * - Blue: New ingredient (<70% or is_new=true)
 */

interface MatchStatusBadgeProps {
  confidence: number;
  isNew: boolean;
}

export function MatchStatusBadge({ confidence, isNew }: MatchStatusBadgeProps) {
  // Determine badge color and label based on confidence and isNew flag
  let badgeColor: string;
  let textColor: string;
  let label: string;

  if (isNew || confidence < 70) {
    // Blue badge for new ingredients or low confidence
    badgeColor = 'bg-blue-100';
    textColor = 'text-blue-800';
    label = 'New';
  } else if (confidence >= 85) {
    // Green badge for high confidence matches
    badgeColor = 'bg-green-100';
    textColor = 'text-green-800';
    label = 'Matched';
  } else {
    // Amber badge for medium confidence (review needed)
    badgeColor = 'bg-amber-100';
    textColor = 'text-amber-800';
    label = 'Review';
  }

  return (
    <span
      className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-medium ${badgeColor} ${textColor}`}
    >
      {label}
      {!isNew && (
        <span className="opacity-75">
          {confidence}%
        </span>
      )}
    </span>
  );
}
